const getNumberOfDatumsInDay = (binning, bins, time, arrayOfTimes) => {
    if (binning) {
        return bins;
    } else {
        const weekOfYear = time.clone().isoWeek();
        const dayOfWeek = time.clone().isoWeekday();
        const datumsInDay = arrayOfTimes.filter((datumee) => datumee.clone().isoWeek() === weekOfYear && datumee.clone().isoWeekday() === dayOfWeek);
        return datumsInDay.length;
    }
};

export default getNumberOfDatumsInDay;
